<template>
  <svg id="Gruppe_158" data-name="Gruppe 158" xmlns="http://www.w3.org/2000/svg" width="25.93" height="25.93" viewBox="0 0 25.93 25.93">
    <path id="Pfad_120" data-name="Pfad 120" d="M0,0H25.93V25.93H0Z" fill="none"/>
    <path id="Pfad_121" data-name="Pfad 121" d="M15.755,14.135H14.9l-.3-.292a7.033,7.033,0,1,0-.758.758l.292.3v.853l5.4,5.391,1.609-1.609Zm-6.483,0a4.862,4.862,0,1,1,4.862-4.862A4.856,4.856,0,0,1,9.273,14.135Z" transform="translate(0.991 0.991)" fill="#757575"/>
  </svg>
</template>

<script>
export default {
name: "magnifyGlass_small"
}
</script>

<style scoped>

</style>